import { addMessageToChat } from '../../commons/superconta-chat';
import { getSuperContaContext, setSuperContaContext } from '../../commons/superconta-context';

export function workflowSeleccionadoChatMessage(id: unknown, descripcion: unknown): string {
  const workflowId = String(id ?? '').trim();
  const name = String(descripcion ?? '').trim();
  if (!workflowId) return '';
  return name ? `seleccioné el Workflow ${workflowId} ${name}` : `seleccioné el Workflow ${workflowId}`;
}

export function announceWorkflowSeleccionado(id: unknown, descripcion: unknown): void {
  const text = workflowSeleccionadoChatMessage(id, descripcion);
  if (text) addMessageToChat(text);
}

export function compactWorkflowDiseno(nodos: unknown, edges: unknown): { nodos: unknown[]; edges: unknown[] } {
  const nodeList = Array.isArray(nodos) ? nodos : [];
  const edgeList = Array.isArray(edges) ? edges : [];
  return {
    nodos: nodeList
      .filter((nodo): nodo is Record<string, unknown> => !!nodo && typeof nodo === 'object')
      .map(nodo => {
        const data = nodo.data && typeof nodo.data === 'object' ? (nodo.data as Record<string, unknown>) : {};
        const position = nodo.position && typeof nodo.position === 'object' ? (nodo.position as Record<string, unknown>) : null;
        return {
          id: nodo.id,
          tipo: nodo.tipo,
          data: { label: data.label ?? '' },
          ...(position
            ? { position: { x: Number(position.x) || 0, y: Number(position.y) || 0 } }
            : {}),
        };
      }),
    edges: edgeList
      .filter((edge): edge is Record<string, unknown> => !!edge && typeof edge === 'object')
      .map(edge => ({ id: edge.id, source: edge.source, target: edge.target })),
  };
}

export function workflowElimineEdgeChatMessage(edgeId: unknown, diseno: unknown): string {
  const id = String(edgeId ?? '').trim();
  if (!id) return '';
  const payload = encodeURIComponent(JSON.stringify(diseno ?? { nodos: [], edges: [] }));
  return `elimine el <a edge-id="${id}">edge</a> de mi <a data="${payload}">workflow</a>`;
}

export function announceElimineEdge(edgeId: unknown, diseno: unknown): void {
  const text = workflowElimineEdgeChatMessage(edgeId, diseno);
  if (!text) return;
  const current = getSuperContaContext() ?? {};
  setSuperContaContext({
    ...current,
    workflow: { ...(current.workflow ?? {}), diseno },
    accion: { tipo: 'eliminar-edge', edgeId: String(edgeId) },
  });
  addMessageToChat(text);
}

export function workflowElimineNodoChatMessage(nodeId: unknown, diseno: unknown): string {
  const id = String(nodeId ?? '').trim();
  if (!id) return '';
  const payload = encodeURIComponent(JSON.stringify(diseno ?? { nodos: [], edges: [] }));
  return `elimine el <a node-id="${id}">nodo</a> de mi <a data="${payload}">workflow</a>`;
}

export function announceElimineNodo(nodeId: unknown, diseno: unknown): void {
  const text = workflowElimineNodoChatMessage(nodeId, diseno);
  if (!text) return;
  const current = getSuperContaContext() ?? {};
  setSuperContaContext({
    ...current,
    workflow: { ...(current.workflow ?? {}), diseno },
    accion: { tipo: 'eliminar-nodo', nodeId: String(nodeId) },
  });
  addMessageToChat(text);
}

export function workflowMejoraLayoutChatMessage(id: unknown, nombre: unknown, diseno: unknown): string {
  const workflowId = String(id ?? '').trim();
  const name = String(nombre ?? '').trim();
  if (!workflowId) return '';
  const payload = encodeURIComponent(JSON.stringify(diseno ?? { nodos: [], edges: [] }));
  const head = name
    ? `quiero mejora la distribución del layout ${workflowId} ${name}`
    : `quiero mejora la distribución del layout ${workflowId}`;
  return `${head} <a data="${payload}">workflow</a>`;
}

export function announceMejoraLayout(id: unknown, nombre: unknown, diseno: unknown): void {
  const text = workflowMejoraLayoutChatMessage(id, nombre, diseno);
  if (!text) return;
  const current = getSuperContaContext() ?? {};
  setSuperContaContext({
    ...current,
    workflow: { ...(current.workflow ?? {}), id, nombre, diseno },
    accion: { tipo: 'mejorar-layout' },
  });
  addMessageToChat(text);
}
